module.exports = __webpack_public_path__ + "static/img/default.e4ec2b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/default.jpg
// module id = HbUk
// module chunks = 43